import type { PersonalPlan } from './subscription.server';

// shared code between client and server
export type PersonalPlanType = 'free' | 'individual' | 'team' | 'enterprise' | 'enterprise-member';
export type PaymentSchedules = 'month' | 'year';

export interface CurrentPlan {
  isActive: boolean;
  period: PaymentSchedules;
  planId: string;
  price: number;
  quantity: number;
  type: PersonalPlanType;
  expirationWarningMessage: string;
  expirationErrorMessage: string;
  periodStart: string;
  periodEnd: string;
  status: 'trialing' | 'active' | 'past_due';
  trialingEnd: string;
}

enum PlanType {
  Essential = 'free',
  Pro = 'team',
  Enterprise = 'enterprise',
  EnterpriseMember = 'enterprise-member',
  Individual = 'individual',
}

export function isDowngradingPlan(old: PersonalPlanType, updating: PersonalPlanType) {
  // enterprise member can not change plan
  if (old === PlanType.Enterprise && updating !== PlanType.Enterprise) {
    return true;
  }
  if (old === PlanType.Pro && (updating === PlanType.Essential || updating === PlanType.Individual)) {
    return true;
  }
  return false;
}

export function getPlanDisplayName(plan: PersonalPlanType) {
  switch (plan) {
    case PlanType.Essential: {
      return 'essentials';
    }
    case PlanType.Pro: {
      return 'pro';
    }
    case PlanType.EnterpriseMember:
    case PlanType.Enterprise: {
      return 'enterprise';
    }
    default: {
      return plan;
    }
  }
}

export function getPlanOfSchedules(plans: PersonalPlan[], priceRequired: boolean) {
  return plans.reduce(
    (acc, plan) => {
      if (plan.price > 0 || !priceRequired) {
        if (plan.period === 'month' && !acc.monthly) {
          acc.monthly = plan;
        } else if (plan.period === 'year' && !acc.yearly) {
          acc.yearly = plan;
        }
      }

      return acc;
    },
    { monthly: null, yearly: null } as { monthly: PersonalPlan | null; yearly: PersonalPlan | null },
  );
}
